import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { FACEBOOK_AUTH_URL, GOOGLE_AUTH_URL, STORAGE_KEY_USER_START_LOGIN } from '../../../const';
import storageService from '../../../service/StorageService';
import { getClearString } from '../../../utils/helper';
import CustomButton from '../../common/Button';
import FacebookLoginIcon from '../../icons/FaceBookLoginIcon';
import GoogleLoginIcon from '../../icons/GoogleLoginIcon';
import styles from './styles.module.scss';

const { REACT_APP_ENVIRONMENT } = process.env;

const FirstAuthStep = () => {
    const { pathname } = useLocation();
    const clearnedStr = getClearString(pathname);
    const { t } = useTranslation();
    const pathGoogle =
        REACT_APP_ENVIRONMENT === 'local'
            ? `http://localhost:8080/api/v1/auth/google?_redirect=${clearnedStr}`
            : `${GOOGLE_AUTH_URL}?_redirect=${clearnedStr}`;
    const pathFb =
        REACT_APP_ENVIRONMENT === 'local'
            ? `http://localhost:8080/api/v1/auth/facebook?_redirect=${clearnedStr}`
            : `${FACEBOOK_AUTH_URL}?_redirect=${clearnedStr}`;

    const onGoogleClick = () => {
        window.location.href = pathGoogle;
    };
    const onFbClick = () => {
        window.location.href = pathFb;
    };

    return (
        <>
            <h2 className={styles.title}>{t('modal.title1')}</h2>
            <p className={styles.subtitle}>{t('modal.label1')}</p>
            <div className={styles.btnWrap}>
                <CustomButton text={t('buttons.google')} onClick={onGoogleClick} LeftIcon={GoogleLoginIcon} />
            </div>
            <div className={styles.btnWrap}>
                <CustomButton text={t('buttons.facebook')} onClick={onFbClick} LeftIcon={FacebookLoginIcon} />
            </div>
        </>
    );
};

export default FirstAuthStep;
